'use strict';

$( function() {
	$( '.col-equal' ).responsiveEqualHeightGrid();

	setupLayout();
	setColBoxes();
} );

$( window ).on( 'load', function() {
	setTimeout( function() {
		setupLayout();
	}, 50 );
} );

$( window ).on( 'resize', function() {
	setupLayout();
} );


$( document ).on( 'scroll', function() {
	if ( $( window ).scrollTop() > 50 ) {
		$( 'body' ).addClass( 'scroll' );
	} else {
		$( 'body' ).removeClass( 'scroll' );
	}

	if ( $( '.featured-image' ).length ) {
		var pageMenuTop = $( '.featured-image' ).outerHeight( true ) - $( window ).scrollTop();

		if ( pageMenuTop > 0 ) {
			$( '#page-menu' ).css( {
				top: pageMenuTop
			} );
		} else {
			$( '#page-menu' ).css( {
				top: 0
			} );
		}
	}

	//$( '.front-page' ).css( {
	//	'background-position': '0 ' + (($( window ).scrollTop() * .3 - 100) + 'px')
	//} );
	//
	//$( '.front-page-container' ).css( {
	//	'opacity': 1 - (1 / 300 * ($( window ).scrollTop() - 50))
	//} );
} );

function setupLayout() {
	if ( $( 'body' ).hasClass( 'page-template-page-contact-php' ) ) {
		var contentHeight = $( '.content-container' ).outerHeight( true );
		$( '.map' ).css( {
			'min-height': $( window ).height() - contentHeight
		} );
	}

	$( '.jumbo-container' ).css( {
		width: $( '.site-main' ).outerWidth( true )
	} );

	// Header Divider
	$( '#header-divider' ).css( {
		'margin-top': ''
	} );

	var remainingHeader = $( '.site-header' ).outerHeight( true ) - $( '.site-header-inner' ).outerHeight( true ) - 50;

	if ( remainingHeader > 0 ) {
		$( '#header-divider' ).css( {
			'margin-top': remainingHeader
		} );
	} else {
		$( '#header-divider' ).css( {
			'margin-top': ''
		} );
	}

	positionPageMenu();
}

function positionPageMenu() {
	$( '.page-menu' ).css( {
		left: $( '.site-header' ).outerWidth( true ) - 2,
		width: $( '.site-main' ).outerWidth( true )
	} );

	if ( $( '.featured-image' ).length ) {
		$( '#page-menu' ).css( {
			top: $( '.featured-image' ).outerHeight( true ) - $( window ).scrollTop()
		} );
	}
}

window.addSelector = function addSelector( container, id, label, name ) {
	container.append( '<div class="filter"><label><input type="checkbox" id="' + id + '" name="' + name + '" value="' + label + '"> ' + label + '</label></div>' );
}

export function setColBoxes() {
	$( '.col-box' ).removeClass( 'child-0' ).removeClass( 'child-1' );

	$( '.col-box:not(.inactive)' ).filter( function( index, element ) {
		return index % 2 == 0;
	} ).addClass( 'child-0' );

	$( '.col-box:not(.inactive)' ).filter( function( index, element ) {
		return index % 2 == 1;
	} ).addClass( 'child-1' );
}

